/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/
import {useEffect, useState} from "react";
import AssetService from "../../../services/asset.service";

const UseUserAssets = (partnerId, accountId, fromAssetId, onNoAssetsReturned) => {
    const [data, setData] = useState([]);
    useEffect(() => {
        let isMounted = true;

        const fallbackToLegacyHierarchy = () => {
            // Legacy (non-Pro) customers have no location/HVAC tags for proassethierarchy to find,
            // so it comes back empty. Fall back to the TT org-hierarchy endpoint, which already
            // returns the same { id, name, children } tree shape (AssetLinkedListDTO).
            AssetService.getassethierarchy(accountId, fromAssetId)
                .then((response) => {
                    if (!isMounted) return;
                    const assets = response.data ?? [];
                    if (assets.length === 0) {
                        onNoAssetsReturned();
                    }
                    setData(assets);
                })
                .catch(() => {
                    if (isMounted) {
                        onNoAssetsReturned();
                        setData([]);
                    }
                });
        };

        if (accountId !== "-1"){
            AssetService.proassethierarchy(partnerId, accountId)
                .then((response) => {
                    if (isMounted) {
                        // Map ProAssetHierarchyDTO to the { id, name, children } tree shape
                        const assets = (response.data?.locations ?? []).map(location => ({
                            id: location.proLocationId,
                            name: location.name,
                            children: (location.hvacSystems ?? []).map(hvac => ({
                                id: hvac.assetId,
                                name: hvac.hvacNickName || hvac.name,
                                children: (hvac.devices ?? []).map(device => ({
                                    id: device.assetId,
                                    name: device.name,
                                    children: []
                                }))
                            }))
                        }));
                        if (assets.length === 0){
                            // Not a Pro/flattened customer (or no tag match) — try the legacy path.
                            fallbackToLegacyHierarchy();
                        } else {
                            setData(assets);
                        }
                    }
                })
                .catch(() => {
                    if (isMounted) {
                        fallbackToLegacyHierarchy();
                    }
                });
        }

        return () => {
            isMounted = false;
        };
    },[accountId, fromAssetId]);

    return data;
}

export default UseUserAssets;